<script setup>
import { ref } from 'vue';

const props = defineProps({
  tables: Array,
  documents: Array,
  model: Object,
});
const activeId = ref('table-0');
const toggle = (id) => {
  activeId.value = activeId.value === id ? null : id;
};
</script>
<template>
  <div class="specs-accordion">
    <div
      v-for="(table, index) in tables"
      :key="'table-' + index"
      class="accordion-item"
      :class="{
                     'navy-color': model.reference === 'Navy',
                     'mint-color' : model.reference === 'Mint',
                     'pink-color' : model.reference === 'Pink',
                     'snow-color' : model.reference === 'Snow',}">
      <button class="accordion-header" @click="toggle('table-' + index)">
        <svg class="arrow-icon" :class="{ 'rotated': activeId === 'table-' + index }"
             width="13" height="20" viewBox="0 0 13 20" fill="none">
          <path
            :class="{
                     'navy-color': model.reference === 'Navy',
                     'mint-color' : model.reference === 'Mint',
                     'pink-color' : model.reference === 'Pink',
                     'snow-color' : model.reference === 'Snow',}"
            d="M-1.02449e-07 17.6563L8.02215 10L-7.71779e-07 2.34375L2.46835 4.60353e-07L13 10L2.46835 20L-1.02449e-07
             17.6563Z"/>
        </svg>
        <span class="title">{{ table.columns[0]?.value || 'Especificação' }}</span>
      </button>
      <div class="accordion-content"
           :style="activeId === 'table-' + index ? { maxHeight: '1000px' } : { maxHeight: '0px' }">
        <div class="accordion-body">
          <div v-for="(row, rowIndex) in table.rows" :key="rowIndex" class="spec-row">
            <div class="spec-label">{{ row.cells[0]?.value }}
              <span>{{ row.cells[1]?.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="documents && documents.length > 0" class="accordion-item"
         :class="{
                     'navy-color': model.reference === 'Navy',
                     'mint-color' : model.reference === 'Mint',
                     'pink-color' : model.reference === 'Pink',
                     'snow-color' : model.reference === 'Snow',}">
      <button class="accordion-header" @click="toggle('docs')">
        <svg class="arrow-icon"
             :class="{'rotated': activeId === 'docs'}"
             width="13" height="20" viewBox="0 0 13 20" fill="none">
          <path
            :class="{
                     'navy-color': model.reference === 'Navy',
                     'mint-color' : model.reference === 'Mint',
                     'pink-color' : model.reference === 'Pink',
                     'snow-color' : model.reference === 'Snow'}"
            d="M-1.02449e-07 17.6563L8.02215 10L-7.71779e-07 2.34375L2.46835 4.60353e-07L13 10L2.46835
          20L-1.02449e-07 17.6563Z"/>
        </svg>
        <span class="title">Informações Técnicas</span>
      </button>
      <div class="accordion-content" :style="activeId === 'docs' ? { maxHeight: '1000px' } : { maxHeight: '0px' }">
        <div class="accordion-body docs-container">
          <div v-for="(group, gIdx) in documents" :key="gIdx" class="doc-group">
            <div v-for="file in group.files" :key="file.id">
                <a :href="file.fullUrl" target="_blank" class="doc-link">
                 {{ group.name }}
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

</style>
